export default [
    {
        name: 'name',
        sortField: 'name',
        callback: 'domain',
        type: 'string',
        dataClass: 'w300',
        useInFilter: true,
        defaultSearch: true,
    },
    {
        name: 'dr',
        sortField: 'dr',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'ip',
        sortField: 'ip',
        type: 'string',
        callback: 'string',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: '__slot:links_numurl',
        sortField: 'numurl',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: '__slot:links_numlink',
        sortField: 'numlink',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: '__slot:it10',
        sortField: 'it10',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: '__slot:it50',
        sortField: 'it50',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'vis',
        sortField: 'vis',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
]
